/*
 * @Description: 获取主题色
 * @version:
 * @Author: linsigao
 * @Date: 2022-01-27 15:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-19 15:25:29
 */
const getPrimaryColor = () => process.env.PRIMARY_COLOR;

const colorList = (process.env.COLORLIST || '').split(',');
const primaryColors = colorList.reduce((object, currentColor, index) => {
	Object.assign(object, {
		[`primaryColor${index}`]: currentColor,
	})
	return object;
}, {
	primaryColor: getPrimaryColor(),
})

const getPrimaryColors = () => primaryColors;

export  {
	getPrimaryColor,
	getPrimaryColors,
};

